import * as React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import DrawerComponent from "../../components/DrawerComponent/DrawerComponent";
import AppBarComponent from "../../components/AppBarComponent/AppBarComponent";
import ContenidoPrincipal from "../../components/PaginaPrincipal/ContenidoPrincipal";

export default function PaginaPrincipal() {
  const [auth] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerOpen = () => setOpen((prev) => !prev);

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      <CssBaseline />
      <AppBarComponent
        open={open}
        handleDrawerOpen={handleDrawerOpen}
        auth={auth}
        anchorEl={anchorEl}
        handleMenu={handleMenu}
        handleClose={handleClose}
        title="Dashboard"
      />
      <DrawerComponent open={open} handleDrawerClose={() => setOpen(false)} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: "auto",
          pt: "116px",
          pb: "56px",
          width: "100%",
        }}
      >
        <ContenidoPrincipal />
      </Box>
    </Box>
  );
}
